'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HairStories = function () {
  function HairStories(el) {
    (0, _classCallCheck3.default)(this, HairStories);

    this.els = {
      el: el,
      filterSelects: (0, _functional.getElements)('.js-Filter_Select', { context: el }),
      showButton: (0, _functional.getElement)('.js-ShowFilters_Button', { context: el }),
      hideButton: (0, _functional.getElement)('.js-HideFilters_Button', { context: el }),
      filterContainer: (0, _functional.getElement)('.js-ShowFilters_Container', { context: el })
    };

    this.setupListeners();
  }

  (0, _createClass3.default)(HairStories, [{
    key: 'setupListeners',
    value: function setupListeners() {
      var _this = this;

      this.els.filterSelects.forEach(function (filterSelect) {
        filterSelect.addEventListener('change', function () {
          location.href = filterSelect.value;
        });
      });

      this.els.showButton.addEventListener('click', function () {
        _this.els.filterContainer.classList.remove('js-ShowFilters_Active');
        _this.els.showButton.classList.remove('js-ShowFilters_Active');
        _this.els.hideButton.classList.add('js-ShowFilters_Active');
      });

      this.els.hideButton.addEventListener('click', function () {
        _this.els.filterContainer.classList.add('js-ShowFilters_Active');
        _this.els.showButton.classList.add('js-ShowFilters_Active');
        _this.els.hideButton.classList.remove('js-ShowFilters_Active');
      });
    }
  }]);
  return HairStories;
}();

exports.default = HairStories;